// lov - List of Values

export interface BusinessUnitName {
    name: string;
    id: string;
}

export class LookUpKeyValueforDomainList {
    requestIdentifier?: string;
    transactionDate?: string;
    success?: boolean;
    lookup?: LookUps[];
    lookups?: LookUps[];
    errors?: Errors[];
    lookupValues?:LookUpCodes[];
    lookupCodes?:LookUpCodes[];
}

export class LookUpName {
    lookupName?: string;
    lookupDescription?: string;
    active?: boolean;
    buId?: string;
    custId?: string;
    fcyId?: string;
}

export class deletLookupValueReq {
    lookUpName?: string;
    buId?: string;
    custId?: string;
    fcyId?: string;
}

export class LookUps {
    lookupId?: string;
    lookupName?: string;
    lookupDescription?: string;
    active?: boolean;
    creationDate?: string;
    createdBy?: string;
    buId?: string;
    custId?: string;
    fcyId?: string;
    lastUpdateDate?: string;
    lastUpdatedBy?: string;
    lookupCodes?: LookUpCodes[];
}

export class LookUpCodes {
    lookupCode?: string;
    lookupCodeDescription?: string;
    active?: boolean;
    destinationSystemValue?: string;
    fcyId?: string;
    buId?: string;
    custId?: string;
    lookupCodeId?: string;
    lookupId?: string;
    lookupValue?: string;
    lookupValueDescription?: string;
}

export class Errors {
    code: string;
    description: string;
}

export class LookupValueReq {
    lookupValuesFb: LookupValuesFb[];
}

export class LookupValuesFb {
    lookupId?: string;
    lookupCodeId?: string;
    destinationSystemValue?: string;
    lookupCode?: string;
    lookupCodeDescription?: string;
    active?: number;
    custId?: string;
    fcyBuCustId ?: BuFac[];
    fcyId?: string;
    buId?: string;
}

export class LookupValueReceipt {
    lookupId?: string;
    lookupCodeId?: string;
    destinationSystemValue?: string;
    lookupCode?: string;
    lookupCodeDescription?: string;
    active?: any;
    custId?: string;
    fcyBuCustId ?: BuFac[];
    fcyId?: string;
    buId?: string;
}

export class BuFac {
    fcyId?: string;
    buId?: string;
    custId?: string;
}

export class LookupRequestMenu {
    active?: string;
    cusId?: string;
    fcyId?: string;
    buId?: string;
    lookupNames ?: string[];
    lookUpName ?: string;
    lookupCode?: string;
}
export class LocationTypeModelArr{
    lookupId?: string;
    lookupValues?:LocationTypeModel[];
}
export class LocationTypeModel{
    destinationSystemValue?:string;
    lookupCode?:string;
    lookupCodeDescription?:string;
}
export class LocationClassModel{
    destinationSystemValue?:string;
    lookupCode?:string;
    lookupCodeDescription?:string;
}
export class LocationClassModelArr{
    lookupId?: string;
    lookupValues?:LocationClassModel[];
}
export class LookupMenu {
  lookupId?: string;
  lookupName?: string;
  lookupDescription?: string;
  active?: boolean;
  lookupCodes?: LookUpCodes[];
}
export class LookupRequest {
    active?: string;
    cusId?: string;
    fcyId?: string;
    buId?: string;
    lookupNames ?: string;
}

export class LookupValueUpdateArr {
    lookupValuesFb : LookupValueUpdateValue[];
}

export class LookupValueUpdateValue {
    lookupName?: string;
    lookupCode?: string;
    lookupDescription?: string;
    destinationSystemValue?: string;
    active?: string;
    custId: string;string;
    customerName: string;
    buId?: string;
    businessUnit?: string;
    fcyId?: string;
    facility?: string;
    lookupCodeId?: string;
    lookupId?: string;
    editable?: string;
    status?: string;
    lookupCodeDescription?: string;
}
export class LookupMenuUpdateArr {
    lookupValuesFb: LookupMenuUpdateValue[];
}

export class LookupMenuUpdateValue {
    lookupId?: string;
    lookupCodeId?: string;
    destinationSystemValue?: string;
    lookupCode?: string;
    lookupCodeDescription?: string;
    active?: string;
    custId?: string;
    fcyId?: string;
    buId?: string;
    dependentLookup?:LocationTypeModelArr[];
}
export class transParamsRes {
    requestIdentifier?: string;
    transactionDate?: string;
    success?: string;
    transParams: transParams[];
}

export class transParams {
    prioritySeq?: number;
    required?: boolean;
    transCode?: string;
    transDesc?: string;
    transId?: number;
    transParamId?: number;
    transVal?: number;
    transValDesc?: string;
}

export class transParamsReq {
    custId?: string;
    buId?: string;
    fcyId?: string;
    transCode?: string;
    transValue?: string;
    transCodes?: string[];
}

export class transCodesReq {
    custId?: string;
    buId?: string;
    fcyId?: string;
    transCodes?: string[];
    transCode?: string;
}
